/**
 * @desc getModeBySupplierIdName
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/srm/getModeBySupplierIdName`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
